import { ApiResponse } from "../types/ApiResponse";
import { makeRequest } from "./makeRequest";
import { Product } from "@Savus-Inc/questionnaire-types";

export const listProducts = async (): Promise<ApiResponse<(Product & { id: string })[]>> => {
  return makeRequest("get", "data/referent/products");
};

export const listCarriers = async (): Promise<ApiResponse<{ id: string; name: string }[]>> => {
  return makeRequest("get", "data/referent/carriers");
};

export const listAvaliableCarriersWithProducts = async (): Promise<
  ApiResponse<{
    carriersWithProducts: {
      id: string;
      name: string;
      products: {
        id: string;
        name: string;
      }[];
    }[];
  }>
> => {
  return makeRequest("get", "data/referent/carriers/carriers-with-products");
};

export const listApplications = async (): Promise<ApiResponse<{ id: string; name: string }[]>> => {
  return makeRequest("get", "data/referent/applications");
};

export const listStates = async (): Promise<
  ApiResponse<
    {
      id: string;
      name: string;
      shortName: string;
      fullName: string;
    }[]
  >
> => {
  return makeRequest("get", "data/referent/states");
};

export const listBusinessTypes = async (
  term: string,
): Promise<ApiResponse<{ data: { id: string; name: string }[] }>> => {
  return makeRequest("get", `data/referent/business-types?term=${term}&limit=1&offset=0`);
};

export type JsonToCsvTemplate = {
  id: string;
  carrierId: string;
  lineOfBusinessId: string;
  entryPointPath: string | null;
  fields: Record<string, { include: boolean; displayName: string; order: number }> | null;
  keysToKeepQuotationMarksFor: string;
};

export const getOrCreateJsonToCsvTemplate = async (
  carrierId: string,
  lineOfBusinessId: string,
): Promise<ApiResponse<JsonToCsvTemplate>> => {
  return makeRequest(
    "get",
    `data/referent/json-to-csv-template?carrierId=${carrierId}&lineOfBusinessId=${lineOfBusinessId}`,
  );
};

export const updateJsonToCsvTemplate = async (
  templateId: string,
  template: Partial<JsonToCsvTemplate>,
): Promise<ApiResponse<JsonToCsvTemplate>> => {
  const fields = template.fields ? JSON.stringify(template.fields) : undefined;
  return makeRequest("patch", `data/referent/json-to-csv-template/${templateId}`, { ...template, fields });
};
